import { useState, useEffect, act } from "react";

const FILTERS = [
  { key: "all", label: "All" },
  { key: "boutiques_and_fashion", label: "Boutiques & Fashion" },
  { key: "home_bakers_and_food", label: "Home Bakers & Food" },
  { key: "fitness_and_coaching", label: "Fitness & Coaching" },
  { key: "jewellery", label: "Jewellery" },
  { key: "restaurants_and_cafes", label: "Restaurants & Cafes" },
  { key: "home_decor_and_art", label: "Home Decor & Art" },
  { key: "skincare_and_wellness", label: "Skincare & Wellness" },
  { key: "salon_and_spas", label: "Salons & Spas" },
];

const ITEMS = [
  // {
  //   id: 1,
  //   thumb:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/lisa-says-gah.png",
  //   large:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/lisa-says-gah.png",
  //   url: "https://lisasaysgah.com",
  //   title: "Lisa Says Gah",
  //   detail: "Playful branding",
  //   categories: ["boutiques_and_fashion"],
  // },
  // {
  //   id: 2,
  //   thumb:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/petite-studio.png",
  //   large:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/petite-studio.png",
  //   url: "https://petitestudionyc.com",
  //   title: "Petite Studio",
  //   detail: "Clean, premium but still indie",
  //   categories: ["boutiques_and_fashion"],
  // },
  // {
  //   id: 3,
  //   thumb:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/goldie-and-ace.png",
  //   large:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/goldie-and-ace.png",
  //   url: "https://goldieandace.com",
  //   title: "Goldie + Ace",
  //   detail: "Kidswear storytelling",
  //   categories: ["boutiques_and_fashion"],
  // },

  // Home Bakers & Food
  // {
  //   id: 4,
  //   thumb:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/flour-shop.png",
  //   large:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/flour-shop.png",
  //   url: "https://flourshop.com",
  //   title: "Flour Shop",
  //   detail: "Colorful + personality-driven",
  //   categories: ["home_bakers_and_food"],
  // },
  {
    id: 5,
    thumb:
      "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/sweet-laurel.png",
    large:
      "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/sweet-laurel.png",
    url: "https://sweetlaurel.com",
    title: "Sweet Laurel",
    detail: "Home Bakers & Food",
    categories: ["home_bakers_and_food"],
  },
  // {
  //   id: 6,
  //   thumb:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/the-goods-tube.png",
  //   large:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/the-goods-tube.png",
  //   url: "https://thegoodstube.com",
  //   title: "The Goods Tube",
  //   detail: "Minimal + product-first",
  //   categories: ["home_bakers_and_food"],
  // },

  // Fitness & Coaching
  // {
  //   id: 7,
  //   thumb:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/the-class.png",
  //   large:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/the-class.png",
  //   url: "https://theclass.com",
  //   title: "The Class",
  //   detail: "Premium + emotional branding",
  //   categories: ["fitness_and_coaching"],
  // },
  {
    id: 8,
    thumb:
      "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/tone-it-up.png",
    large:
      "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/tone-it-up.png",
    url: "https://toneitup.com",
    title: "Tone It Up",
    detail: "Fitness & Coaching",
    categories: ["fitness_and_coaching"],
  },
  // {
  //   id: 9,
  //   thumb:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/coreplus-studio.png",
  //   large:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/coreplus-studio.png",
  //   url: "https://core-plus.com.au",
  //   title: "CorePlus Studio",
  //   detail: "Fitness studio branding",
  //   categories: ["fitness_and_coaching"],
  // },

  // Jewellery
  // {
  //   id: 10,
  //   thumb:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/mejuri.png",
  //   large:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/mejuri.png",
  //   url: "https://mejuri.com",
  //   title: "Mejuri",
  //   detail: "Fine jewellery, good reference",
  //   categories: ["jewellery"],
  // },
  {
    id: 11,
    thumb:
      "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/by-charlotte.png",
    large:
      "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/by-charlotte.png",
    url: "https://bycharlotte.com.au",
    title: "By Charlotte",
    detail: "Jewellery",
    categories: ["jewellery"],
  },
  // {
  //   id: 12,
  //   thumb:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/gldn.png",
  //   large:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/gldn.png",
  //   url: "https://gldn.com",
  //   title: "GLDN",
  //   detail: "Personalized jewellery",
  //   categories: ["jewellery"],
  // },

  // Restaurants & Cafes
  {
    id: 13,
    thumb:
      "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/cafe-gratitude.png",
    large:
      "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/cafe-gratitude.png",
    url: "https://cafegratitude.com",
    title: "Cafe Gratitude",
    detail: "Restaurants & Cafes",
    categories: ["restaurants_and_cafes"],
  },
  // {
  //   id: 14,
  //   thumb:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/gjusta.png",
  //   large:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/gjusta.png",
  //   url: "https://gjusta.com",
  //   title: "Gjusta",
  //   detail: "Artisan bakery & deli",
  //   categories: ["restaurants_and_cafes"],
  // },
  // {
  //   id: 15,
  //   thumb:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/higher-ground.png",
  //   large:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/higher-ground.png",
  //   url: "https://highergroundmelbourne.com.au",
  //   title: "Higher Ground",
  //   detail: "Café + restaurant branding",
  //   categories: ["restaurants_and_cafes"],
  // },

  // Home Decor & Art
  // {
  //   id: 16,
  //   thumb:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/east-fork.png",
  //   large:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/east-fork.png",
  //   url: "https://eastfork.com",
  //   title: "East Fork",
  //   detail: "Handmade pottery brand",
  //   categories: ["home_decor_and_art"],
  // },
  {
    id: 17,
    thumb:
      "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/maison-balzac.png",
    large:
      "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/maison-balzac.png",
    url: "https://maisonbalzac.com",
    title: "Maison Balzac",
    detail: "Home Decor & Art",
    categories: ["home_decor_and_art"],
  },
  // {
  //   id: 18,
  //   thumb:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/areaware.png",
  //   large:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/areaware.png",
  //   url: "https://areaware.com",
  //   title: "Areaware",
  //   detail: "Design objects & gifts",
  //   categories: ["home_decor_and_art"],
  // },
  {
    id: 19,
    thumb:
      "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/huehoppers.png",
    large:
      "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/huehoppers.png",
    url: "https://huehoppers.com/",
    title: "HueHoppers",
    detail: "Boutiques & Fashion",
    categories: ["boutiques_and_fashion"],
  },

  {
    id: 22,
    thumb:
      "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/go-to-skincare.png",
    large:
      "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/go-to-skincare.png",
    url: "https://gotoskincare.com",
    title: "Go-To Skincare",
    detail: "Skincare & Wellness",
    categories: ["skincare_and_wellness"],
  },
  // {
  //   id: 23,
  //   thumb:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/herbivore-botanicals.png",
  //   large:
  //     "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/herbivore-botanicals.png",
  //   url: "https://herbivorebotanicals.com",
  //   title: "Herbivore Botanicals",
  //   detail: "Natural beauty, minimal aesthetic",
  //   categories: ["skincare_and_wellness"],
  // },

  {
    id: 24,
    thumb:
      "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/fringeny-salon.png",
    large:
      "https://pluralcode.s3.ap-south-1.amazonaws.com/sis_portfolio/fringeny-salon.png",
    url: "https://fringeny.com",
    title: "Fringeny Salon",
    detail: "Salons & Spas",
    categories: ["salon_and_spas"],
  },
];

const Portfolio = () => {
  const [activeFilter, setActiveFilter] = useState("all");
  const [items, setItems] = useState(ITEMS);

  const isVisibleForFilter = (item) =>
    activeFilter === "all" || item.categories.includes(activeFilter);

  useEffect(() => {
    console.log(activeFilter);
    const filteredItems =
      activeFilter === "all"
        ? ITEMS
        : ITEMS.filter((i) => i.categories.indexOf(activeFilter) > -1);
    setItems(filteredItems);
  }, [activeFilter]);
  return (
    <section id="portfolio" className="section-padding-t gray-bg">
      <div className="container text-center">
        <h3 className="mt-sm">
          Our <span className="text-light">Portfolio</span>
          <span style={{ color: "#e6ae49" }}>.</span>
        </h3>
        <p className="lead">We take pride in our work.</p>
      </div>
      <div className="container-fluid">
        {/* <div className="row">
          <ul className="col portfolio-filter categories-filter">
            {FILTERS.map((filter) => (
              <li key={filter.key}>
                <a
                  href="#portfolio"
                  className={`categories ${activeFilter === filter.key ? "active" : ""}`}
                  onClick={(event) => {
                    event.preventDefault();
                    setActiveFilter(filter.key);
                  }}
                >
                  {filter.label}
                </a>
              </li>
            ))}
          </ul>
        </div> */}
        <div className="portfolio-grid-fit row gallery-popup">
          {items.map((item) => (
            <div
              key={item.id}
              className={`portfolio-item ${item.categories.join(" ")} ${
                isVisibleForFilter(item) ? "" : "portfolio-item--hidden"
              }`.trim()}
            >
              <div className="portfolio-box">
                <a
                  className="portfolio-image-wrap"
                  href={item.large}
                  target="_blank"
                  rel="noreferrer"
                  title={item.title}
                >
                  <img
                    style={{ height: "21em" }}
                    src={item.thumb}
                    alt={`Portfolio ${item.id}`}
                  />
                </a>
                <div className="portfolio-caption">
                  <div className="portfolio-caption-tb">
                    <div className="portfolio-caption-tb-cell">
                      <h5>{item.title}</h5>
                      <p>{item.detail}</p>
                      <ul className="portfolio-btn-wraper">
                        <li>
                          <a
                            className="btn btn-color"
                            href={item.url}
                            target="_blank"
                            rel="noreferrer"
                            title="Open project"
                          >
                            <i className="fa fa-external-link" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
